import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useDocumentContext } from '../../../context/complexDocumentContext';
import { LinkBlockSidebar } from './LinkBlockSidebar';
import {
  CONTEXT_KEYS,
  TEMPLATE_TYPE,
  useArtboardContext,
} from '../../../context/complexArtboardContext';
import { LINK_BLOCK } from '../../../utils/complexDocumentConstants';

const SOCIAL_LINK_ASSETS = {
  FACEBOOK: process.env.REACT_APP_FACEBOOK_IMG_URL,
  LINKEDIN: process.env.REACT_APP_LINKEDIN_IMG_URL,
  INSTAGRAM: process.env.REACT_APP_INSTAGRAM_IMG_URL,
  TWITTER: process.env.REACT_APP_TWITTER_IMG_URL,
  WHATSAPP: process.env.REACT_APP_WHATSAPP_IMG_URL,
};

const LinkBlockContainer = styled.div``;

const Img = styled.img`
  display: inline-block;
  width: 30px;
`;

const hasParagraphContent = linkContents => {
  return linkContents?.some(
    ({ content, contentType }) => !!content?.trim() && contentType === 'PARAGRAPH',
  );
};

export const LinkBlock = props => {
  const { itemUUID, getElementStyles, parentUUID, editable, onClickBlockSelection } = props;

  const customSelector = useCallback(store => store[itemUUID], [itemUUID]);
  const [linkBlock] = useDocumentContext(customSelector, `LinkBlock-${itemUUID}`);

  const artboardContextSelector = useCallback(
    store => ({
      currentBlock: store[CONTEXT_KEYS.CURRENT_BLOCK] === itemUUID,
      selectedBlocks: store[CONTEXT_KEYS.SELECTED_BLOCKS],
      isDocumentOrFlowDesign: [TEMPLATE_TYPE.DOCUMENT, TEMPLATE_TYPE.FLOW].includes(
        store[CONTEXT_KEYS.CURRENT_DESIGN],
      ),
    }),
    [],
  );
  const [
    { currentBlock, selectedBlocks, isDocumentOrFlowDesign },
    updateArtboard,
  ] = useArtboardContext(artboardContextSelector, `LinkBlock-${itemUUID}`);

  const handleDoubleClick = () => {
    if (editable) {
      updateArtboard({
        [CONTEXT_KEYS.CURRENT_BLOCK]: itemUUID,
        [CONTEXT_KEYS.CURRENT_BLOCK_TYPE]: LINK_BLOCK,
        [CONTEXT_KEYS.ELEMENT_SETTINGS_VISIBLE]: true,
        [CONTEXT_KEYS.CURRENT_PAGE]: parentUUID,
        [CONTEXT_KEYS.PAGE_LAYOUT_VISIBLE]: false,
        [CONTEXT_KEYS.BLOCK_SETTINGS_VISIBLE]: false,
      });
    }
  };

  const handleSingleclick = e => {
    if (editable && isDocumentOrFlowDesign && !currentBlock) {
      if (e.ctrlKey || e.metaKey) {
        onClickBlockSelection({ itemUUID, parentUUID });
      }
    }
  };

  const closeSidebar = () => {
    updateArtboard({
      [CONTEXT_KEYS.CURRENT_BLOCK]: '',
      [CONTEXT_KEYS.ELEMENT_SETTINGS_VISIBLE]: false,
      [CONTEXT_KEYS.CURRENT_PAGE]: '',
      [CONTEXT_KEYS.CURRENT_BLOCK_TYPE]: '',
    });
  };

  const { contents, style } = linkBlock;
  const { padding, spacing, backgroundColor, alignment } = style;
  const blockSelected = selectedBlocks.includes(itemUUID);

  return (
    <>
      <LinkBlockContainer
        data-uuid={itemUUID}
        style={{
          position: 'relative',
          backgroundColor: blockSelected ? '#ACCEF7' : backgroundColor,
          display: 'flex',
          justifyContent: alignment,
          columnGap: spacing + 'px',
          padding:
            padding &&
            `${padding?.top}px ${padding?.right}px ${padding?.bottom}px ${padding?.left}px`,
          zIndex: currentBlock && 2,
        }}
        onMouseMove={e =>
          editable && !currentBlock && getElementStyles && getElementStyles(e, itemUUID)
        }
        onDoubleClick={handleDoubleClick}
        onClick={handleSingleclick}
      >
        {contents.map(el => {
          const { contentType, contents: linkContents } = el;
          if (!hasParagraphContent(linkContents)) {
            return <></>;
          }
          return <Img src={SOCIAL_LINK_ASSETS[contentType]} alt={el.content} />;
        })}
      </LinkBlockContainer>
      {currentBlock && (
        <LinkBlockSidebar
          linkBlock={linkBlock}
          parentUUID={parentUUID}
          closeSidebar={closeSidebar}
        />
      )}
    </>
  );
};
